<button (click)="goBack()" class="btn btn-outline-secondary btn-sm" title="Go back">
    <i class="fi fi-rr-arrow-left me-1"></i>
    Back
</button>
